import { useStyles } from '../styles/OrangeButtonStyles.styles';
import React from 'react';
import { LoadingButton } from '@mui/lab';

interface OrangeButtonProps {
    onClick: () => void;
    loading?: boolean;
    children: React.ReactNode;
    style?: React.CSSProperties;
}

export const OrangeButton = ({ onClick, loading, style, children }: OrangeButtonProps) => {
    const styles = useStyles();

    return (
        <LoadingButton
            loading={loading}
            className={styles.orangeButton}
            style={style}
            variant={'contained'}
            onClick={onClick}>
            {children}
        </LoadingButton>
    );
};
